import { Box, Typography, Chip, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import StaticPage from '../../components/StaticPage';

const areas = ['Engineering', 'Product', 'Creator Success', 'Growth'];

export default function CareersPage() {
    return (
        <StaticPage title="Careers" subtitle="We're not actively hiring for listed roles right now.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    The Creator Match is a small, fast-moving team working on the creator/brand matching problem.
                    We don't have open roles posted at the moment, but we're always glad to hear from people
                    who are excited about the space, especially around:
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {areas.map((a) => (
                        <Chip key={a} label={a} color="secondary" variant="outlined" />
                    ))}
                </Box>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    If that's you, reach out through the{' '}
                    <Link component={RouterLink} to="/contact" color="secondary.main">Contact</Link> page
                    with a short note about what you'd want to work on — we read everything, even without an open req.
                </Typography>
            </Box>
        </StaticPage>
    );
}
